import { useSearchParams } from 'react-router-dom'

import { Button, IconArrowInbox } from '@sequencehq/core-components'

import { useCreditNotesCsvExport } from './useCreditNotesCsvExport'

export const CreditNotesExportToCsv = () => {
  const [searchParams] = useSearchParams()

  const { download } = useCreditNotesCsvExport()

  const buttonProps = {
    variant: 'secondary',
    leadingIcon: <IconArrowInbox color="initial" />,
    'data-testid': 'creditNotes.exportToCsv'
  } as const

  if (!download.available) {
    return null
  }

  return (
    <Button
      {...buttonProps}
      onClick={() => download.onClick(Object.fromEntries(searchParams))}
    >
      Export to CSV
    </Button>
  )
}
